























































































































































































































































































































































/* tslint:disable: max-file-line-count cyclomatic-complexity */

import {Component, Vue, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'

import {BookingMode, BookRequest, CheckItem, Highlight, VehicleSlot, VehicleType} from '@/lib/kepler/interfaces'
import {TermOfServicesState} from '@/store/modules/termOfServices'
import {SubscriptionsState} from '@/store/modules/subscriptions'
import {ProfileState} from '@/store/modules/profile'
import {DialogState, PopupState} from '@/store'
import ServiceMesh from '@/lib/serviceMesh'
import Validations from '@/lib/Validations'
import {EventBus} from '@/main'
import Utils from '@/utils'
import moment from 'moment'

import ErrorView from '@/views/Error.vue'
import AddCredit from '@/views/AddCredit.vue'
import ConfirmDialog from '@/views/ConfirmDialog.vue'
import FuelPinDialog from '@/views/FuelPinDialog.vue'
import BookingEdit from '@/views/Booking/BookingEdit.vue'
import ChangeLangDialog from '@/views/ChangeLangDialog.vue'
import AlreadyHasAccount from '@/views/AlreadyHasAccount.vue'
import PhoneVerificationView from '@/views/PhoneVerification.vue'
import ForceTerminateDialog from '@/views/Booking/ForceTerminateDialog.vue'
import VehicleConfirmBooking from '@/views/Vehicle/VehicleConfirmBooking.vue'
import VehicleBookingDateTimeSelect from '@/views/Vehicle/VehicleBookingDateTimeSelect.vue'
import VehicleBookingAddMemoDialogView from '@/views/Vehicle/VehicleBookingAddMemoDialog.vue'

import UpdateProfileImageDialog from '@/components/profile/UpdateProfileImageDialog.vue'
import PinRequestCallback from '@/views/Vehicle/PinRequestCallback.vue'
import {FlowInputsState} from '@/store/modules/flowInputs'
import {VSlider} from 'vuetify/lib'
import ChecklistItem from '@/components/ChecklistItem.vue'
import Checklist from '@/components/Checklist.vue'
import ForceTerminateChecklist from '@/views/Booking/ForceTerminateChecklist.vue'
import LoginDialog from '@/views/LoginDialog.vue'
import VehicleAddReportDialog from '@/views/Vehicle/VehicleAddReportDialog.vue'

@Component({
  components:
    {
      Checklist,
      ChecklistItem,
      VSlider,
      AccordionContent: Utils.loadComponent('proxy/Accordion/AccordionContent'),
      HorizontalHighlight: Utils.loadComponent('HorizontalHighlight'),
      CardSubscription: Utils.loadComponent('subscriptions/CardPlan'),
      Accordion: Utils.loadComponent('proxy/Accordion/Accordion'),
      CardButtonNumeric: Utils.loadComponent('CardButtonNumeric'),
      ToggleableButton: Utils.loadComponent('ToggleableButton'),
      TextField: Utils.loadComponent('proxy/Inputs/TextField'),
      SelectTag: Utils.loadComponent('proxy/Inputs/SelectTag'),
      PhoneWithPrefix: Utils.loadComponent('PhoneWithPrefix'),
      CheckBox: Utils.loadComponent('proxy/Inputs/CheckBox'),
      CardWithReport: Utils.loadComponent('CardWithReport'),
      CardText: Utils.loadComponent('proxy/Card/CardText'),
      TabItems: Utils.loadComponent('proxy/Tabs/TabItems'),
      MonthSwitcher: Utils.loadComponent('MonthSwitcher'),
      TabItem: Utils.loadComponent('proxy/Tabs/TabItem'),
      Container: Utils.loadComponent('proxy/Container'),
      GradientCard: Utils.loadComponent('GradientCard'),
      WarningNote: Utils.loadComponent('WarningNote'),
      StatusLabel: Utils.loadComponent('StatusLabel'),
      FlowTest: Utils.loadComponent('flow/FlowTest'),
      CustomIcon: Utils.loadComponent('CustomIcon'),
      CardButton: Utils.loadComponent('CardButton'),
      CardDriver: Utils.loadComponent('CardDriver'),
      Divider: Utils.loadComponent('proxy/Divider'),
      Card: Utils.loadComponent('proxy/Card/Card'),
      Tabs: Utils.loadComponent('proxy/Tabs/Tabs'),
      Layout: Utils.loadComponent('proxy/Layout'),
      LoopingBG: Utils.loadComponent('LoopingBG'),
      Avatar: Utils.loadComponent('proxy/Avatar'),
      Tab: Utils.loadComponent('proxy/Tabs/Tab'),
      Badge: Utils.loadComponent('proxy/Badge'),
      Chip: Utils.loadComponent('proxy/Chip'),
      Icon: Utils.loadComponent('proxy/Icon'),
      Btn: Utils.loadComponent('proxy/Btn'),
      TopBar: Utils.loadComponent('TopBar'),
      Button: Utils.loadComponent('Button'),
    },
})
export default class Dev extends Vue {
  @State('profile') public profileState!: ProfileState
  @State('subscriptions') public subscriptionsState!: SubscriptionsState
  @State('termOfServices') public TermsOfServiceState!: TermOfServicesState
  @State('flowInputs') public flowInputs!: FlowInputsState
  @State((state) => state.profile.debugMode) public debugMode!: boolean

  @Action('getPlans') public getPlans: any
  @Action('openPopup') public openPopup: any
  @Action('openDialog') public openDialog: any
  @Action('getSubscriptions') public getSubscriptions: any
  @Action('setDebugMode') public setDebugMode: any

  public rules: any = Validations.rules

  public phoneNumber: string = ''

  public testBool1: boolean = false

  public flowName: string = ''
  public flowPage: number = 0

  public currentTab: number = 0
  public customGradient: any = {
    background: 'radial-gradient(circle at 100%, #333, #333 50%, #eee 75%, #333 75%)',
  }
  public customGradient2: any = {
    background: 'radial-gradient(circle at right, #C86DD7 -30%, #3023AE 141%)',
    boxShadow: 'black 0px 3px 30px -5px inset',
  }
  public highlights: Highlight[] = [
    {
      title: 'COST PER HOUR',
      content: '€1.75',
      subcontent: '/ h',
    },
    {
      title: 'COST PER KM',
      content: '€0.35',
      subcontent: '/ km',
    },
    {
      title: 'SUBSCRIPTION',
      content: '€12',
      subcontent: '/ month',
    },
  ]
  public bookingConfirmSelected = {
    bookingMode: null,
    vehicleType: null,
    action: null,
  }
  public bookingConfirmData = {
    bookingModes: ['RT', 'FF', 'OWFF'],
    vehicleTypes: ['car'],
    actions: ['confirm', 'keep'],
  }
  private fakeVehicleSlot: VehicleSlot = {
    id: 'g4xgLm',
    name: 'Via S. Tommaso D\'Aquino - Monreale',
    lot: {
      id: 'ZEdw40',
      name: 'Via S. Tommaso D\'Aquino - Monreale',
      picture: 'https://core.staging.playmoove.com/res/vehicle-404.png',
      position: {
        latitude: 39.248229,
        longitude: 9.118096,
      },
    },
    reservation_type: BookingMode.RT,
    distance: 2520.1457727561733,
    position: {
      latitude: 39.248229,
      longitude: 9.118096,
    },
    vehicle: {
      id: 'oaok1a',
      plate: 'FJ578DR',
      model: '108',
      brand: 'Peugeot',
      brand_logo: 'https://s3.staging.playmoove.com/playmoove-staging/vehicle-brands/peugeot-logo.png',
      door: 'LOCKED',
      color: 'White',
      fuel_type: 'PETROL',
      fuel_level: 39,
      category: {
        id: 'ZEdw40',
        name: 'City-Compact',
        description: 'Auto per tutti i giorni',
        type: VehicleType.CAR,
        damage_picture: '',
        picture: '',
      },
      picture: 'https://s3.staging.playmoove.com/playmoove-staging/vehicles/108.png',
      attributes: [{
        id: 'g4xL41',
        name: 'helmet',
        slug: 'helmet',
        description: 'bike helmet',
        recommended: 0,
        value: 'helmet',
        type: 'string',
      }, {
        id: '1m2Jml',
        name: 'on board computer',
        slug: 'on-board-computer',
        description: 'on board computer',
        recommended: 0,
        value: 'yes',
        type: 'string',
      }],
      notes: [],
      instructions: [],
    },
    base_rate: {
      id: '84rOEW',
      name: 'ONE CITY COMPACT',
      plan: {
        id: '34v64K',
        name: 'ONE',
      },
      vehicle_category: {
        name: 'City-Compact',
        damage_picture: '',
        id: '00',
        description: 'string',
        type: VehicleType.CAR,
        picture: '',
      },
      time_rate: {
        id: '1m2Jml',
        name: '5.0-hour',
        description: null,
        time_cost: 5,
        driving_time_cost: 5,
        time_cost_cycle: 60,
      },
      distance_rate: {
        id: '34v64K',
        name: '0.35-km',
        distance_cost: 0.35,
        distance_cost_cycle: 1,
      },
      booking_mode: '',
      disabled: 0,
      is_base_rate: 1,
      valid_from: null,
      valid_to: null,
      time_overrides: [],
      distance_overrides: [],
      bulk_overrides: [],
    },
  }
  private fakeBookRequest: BookRequest = {
    start: moment().unix(),
    end: moment().add(30, 'minutes').unix(),
    plate: 'f4k3P14t3',
    memo: '',
  }
  private fakeReservation = {
    id: 'EnLMkm',
    number: 8626,
    type: 'FF',
    start: '2018-12-04 15:11:45',
    end: '2018-12-11 15:11:45',
    status: 'CONFIRMED',
    driver: {
      id: 'N4Nbl4',
      main_driver: true,
      status: 'ACTIVE',
      profile_picture: 'https://core.staging.playmoove.com/api/frontoffice/v2/drivers/profile_picture?driver_id=N4Nbl4&token=b14b32ba9950367236865919bab2d7a5184410a8',
      username: 'user',
      title: 'Mr',
      name: 'Riccardo',
      surname: 'Scasseddu',
      birthdate: '1976-02-04',
      gender: 'M',
      email: '42@playmoove.com',
      phone: '3290006059',
      mobile: '+393290006050',
      address: {
        country: 'Belize',
        region: 'VT',
        city: 'Port Constantinstad',
        postal_code: '21198',
        street: '102 Haven Streets Apt. 282',
      },
    },
    vehicle_slot: {
      id: 'kaZqOE',
      name: 'Machiavelli Float',
      lot: {
        id: 'qEJY4O',
        name: 'Machiavelli Float',
        picture: 'https://s3.staging.playmoove.com/playmoove-staging/parking-lot/3UNLdKkibUxwOk8aMNxALCkwnB4aymrGfjCZwNNV.png',
        position: {latitude: 0, longitude: 0},
      },
      reservation_type: 'FF',
      distance: null,
      position: {latitude: 39.216381, longitude: 9.112661},
      vehicle: {
        id: 'v4zeym',
        plate: 'FP088EJ',
        model: 'AYGO',
        brand: 'Toyota',
        brand_logo: 'https://core.staging.playmoove.com/res/vehicle-404.png',
        door: 'LOCKED',
        color: 'Grigio',
        fuel_type: 'PETROL',
        fuel_level: 92,
        category: {
          id: 'ZEdw40',
          name: 'City-Compact',
          description: 'Auto per tutti i giorni',
          type: 'Car',
        },
        picture: 'https://s3.staging.playmoove.com/playmoove-staging/vehicles/aygo.png',
        attributes: [],
        notes: [],
        instructions: [],
      },
      base_rate: {
        id: 'VEWwEX',
        name: 'UNI CITY COMPACT',
        plan: {id: 'VEWwEX', name: 'UNI'},
        vehicle_category: {name: 'City-Compact'},
        time_rate: {
          id: 'VEWwEX',
          name: '0.99-hour',
          description: null,
          time_cost: 0.99,
          driving_time_cost: 0.99,
          time_cost_cycle: 60,
        },
        distance_rate: {id: 'VEWwEX', name: '0.3-km', distance_cost: 0.31, distance_cost_cycle: 1},
      },
    },
    trips: [{
      id: '4PllY4',
      start: '2018-12-04 22:23:34',
      end: '2018-12-04 22:32:05',
      latitude: 39.223831,
      longitude: 9.12662,
      distance: 1,
      speed: 7.05,
      fuel_level: 8,
      start_timestamp: 1543958614,
      end_timestamp: 1543959125,
    }],
    cost: null,
    memo: null,
    distance: 3,
    fuel_level: 7,
    created: '2018-12-04 15:11:45',
    updated: '2018-12-05 10:40:58',
    start_timestamp: 1543932705,
    end_timestamp: 1544537505,
    created_timestamp: 1543932705,
    updated_timestamp: 1544002858,
  }
  private checkList = [
    {
      id: 'item1',
      title: 'ignition is off',
      description: 'I\'ve checked the control panel and there are no blinking lights.',
      icon: 'mdi-key-variant',
    },
    {
      id: 'item2',
      title: 'combobulator is off',
      description: 'I don\'t know what it is but I\'ve checked very carefully.',
      icon: 'mdi-lock-outline',
    },
    {
      id: 'item3',
      title: 'reaction control system is nominal',
      description: 'Also, I\'ve degaussed the flywheels thoroughly.',
      icon: 'mdi-flash-off',
    },
    {
      id: 'item4',
      title: 'I\'ve parked decently',
      description: 'I\'ve checked with mission control the stability of the orbit.',
      icon: 'mdi-parking',
    },
  ]
  private checkListValues = {}

  public get testBool2() {
    return !this.testBool1
  }

  public set testBool2(val) {
    this.testBool1 = !val
  }

  public get flowNames() {
    const arr: string[] = []
    Object.keys(this.flowInputs).forEach((s) => {
      arr.push(s)
    })
    return arr
  }

  public get selectedFlow() {
    if (this.flowNames && this.flowName && this.flowNames.includes(this.flowName)) {
      return this.flowInputs[this.flowName]
    }
    return null
  }

  public get flowPages() {
    return this.selectedFlow ? this.selectedFlow.steps.length - 1 : null
  }

  @Watch('selectedFlow', {immediate: true})
  public onSelectedFlowChange() {
    this.flowPage = 0
  }

  public changePage(step: number) {
    this.flowPage = step
  }

  public openConfirm() {
    this.openDialog(new DialogState(ConfirmDialog, {
      imageState: 'success.svg',
    }))
  }

  public openAlert() {
    this.openDialog(new DialogState(ErrorView, {
      code: 'code 123',
      title: 'title',
      subtitle: 'error subtitle',
      singleAction: true,
    }))
  }

  public openSingleAction() {
    this.openDialog(new DialogState(ConfirmDialog, {
      imageState: 'logo.png',
      confirmText: 'confirmText',
      singleAction: true,
      emitConfirm: false,
    }))
  }

  public openStuff(repeatTimes: number = 5, intervalBetween: number = 250) {
    const repeatXI = (callback: () => any, interval: number, repeats: number) => {
      const trigger = () => {
        callback()
        --repeats
        if (repeats === 0) {
          clearInterval(timer)
        }
      }
      const timer = setInterval(trigger, interval)
      trigger()
    }

    let iteration = 1

    const dialog = () => {
      this.openDialog(new DialogState(ConfirmDialog, {
        imageState: 'logo.png',
        confirmText: 'okay',
        code: `repeated ${iteration} times of ${repeatTimes}`,
        title: '',
        subtitle: '',
        singleAction: true,
        emitConfirm: false,
      }))

      iteration++
    }
    repeatXI(dialog, intervalBetween, repeatTimes)
  }

  public openConfirmBooking(bookingMode: BookingMode, vehicleType: VehicleType, action: string = 'confirm') {
    const vehicleSlot = this.fakeVehicleSlot
    this.fakeVehicleSlot.reservation_type = bookingMode
    this.fakeVehicleSlot.vehicle.category.type = vehicleType
    this.openPopup(new PopupState(VehicleConfirmBooking, {vehicleSlot, action}, null, true))
  }

  public mounted() {
    this.$log('all is fine.', 0)
    this.$log('this is fine', 1)
    this.$log('this is not fine', 2)
    this.$log('EVERYTHING IS BURNING', 3)

    this.getSubscriptions()
    this.getPlans()
    EventBus.$on('dialogConfirm', (payload: any) => {
      alert('confirmed, payload: \n' + payload)
    })

    const serviceCazzo = new ServiceMesh()
    this.bookingConfirmData.bookingModes = serviceCazzo.bookingModes
    this.bookingConfirmData.vehicleTypes = serviceCazzo.vehicleTypes
  }

  public beforeDestroy() {
    EventBus.$off('dialogConfirm')
  }

  public dialog(type: string) {
    switch (type) {
      case 'confirm':
        this.openConfirm()
        break
      case 'error':
        this.openAlert()
        break
      case 'ChangeLang':
        this.openDialog(new DialogState(ChangeLangDialog, {}))
        break
      case 'phoneVerification':
        this.openDialog(new DialogState(PhoneVerificationView, {
          mobileNumber: this.phoneNumber,
          isDialog: true,
        }))
        break
      case 'pinRequest':
        this.openDialog(new DialogState(PinRequestCallback, {
            reservation: this.fakeReservation,
            showCloseButton: true,
            confirmCallback: () => {
              this.$log('pinRequest dialog confirmed', 1)
            },
            cancelCallback: () => {
              this.$log('pinRequest dialog cancelled', 1)
            },
          },
        ))
        break
      case 'fuelPin':
        this.openDialog(new DialogState(FuelPinDialog, {
          imageState: 'success.svg',
          confirmText: 'close',
          pin: 12345,
          odometer: 12345,
          callback: () => {
            alert('callback')
          },
          data: this.$t('vehicle.refuel.necessary'),
          singleAction: true,
          emitConfirm: false,
        }))
        break
      case 'memo':
        this.openDialog(new DialogState(VehicleBookingAddMemoDialogView, {
          vehicle: this.fakeVehicleSlot.vehicle,
          bookRequest: this.fakeBookRequest,
          confirmCallback: () => {
            alert('confirmed')
          },
          cancelCallback: () => {
            alert('cancelled')
          },
        }))
        break
      case 'addCredit':
        this.openDialog(new DialogState(AddCredit, {
          confirmText: '*Buy*',
        }))
        break
      case 'book':
        this.openDialog(new DialogState(VehicleBookingDateTimeSelect, {
          vehicleSlot: this.fakeVehicleSlot,
          bookRequest: this.fakeBookRequest,
        }, null, false, 'quickBookingDateSelected'))
        break
      case 'terminate':
        const checkBoxLabel = this.$t('booking.terminate_mode.accept_undesirable')
        this.openDialog(new DialogState(ForceTerminateDialog, {checkBoxLabel}))
        break
      case 'bookingEdit':
        this.openDialog(new DialogState(BookingEdit, {
          reservation: this.fakeReservation,
          confirmCallback: () => {
            alert('confirm')
          },
          cancelCallback: () => {
            alert('cancel')
          },
        }))
        break
      case 'profileImage':
        this.openDialog(new DialogState(UpdateProfileImageDialog, {
          cancelCallback: () => {
            return null
          },
          uploadCallback: () => {
            alert('upload callback')
          },
        }))
        break
      case 'alreadyHasAccount':
        const error = {
          result: 'Hai già un account',
          result_code: 'exceptions.system.already-has-account-exception',
          messages: ['Recupera la tua password per accedere'],
        }
        this.openDialog(new DialogState(AlreadyHasAccount, {err: error}, null, false, null))
        break
      case 'forceTerminateChecklist':
        this.openDialog(new DialogState(ForceTerminateChecklist, {
          list: this.checkList,
          title: 'I\'m pretty sure that...',
        }))
        break
      case 'loginDialog':
        this.openDialog(new DialogState(LoginDialog, {}, null, true, null))
        break
      case 'addReportDialog':
        this.openDialog(new DialogState(VehicleAddReportDialog, {
          vehicleSlot: this.fakeReservation.vehicle_slot,
          vehicle: this.fakeReservation.vehicle_slot.vehicle,
          reportType: null,
          reservationId: this.fakeReservation.id,
        }))
    }
  }

  public biometricsAvailable() {
    const x = new Promise((resolve, reject) => {
      (window as any).Fingerprint.isAvailable(resolve, reject)
    })
    const alert = (r: any) => {
      alert(r)
    }
    x.then(alert).catch(alert)
  }

  public biometricsShow() {
    return new Promise((resolve, reject) => {
      (window as any).Fingerprint.isAvailable(resolve, reject)
    })
  }

  public exitForward() {
    alert('exit forward')
  }

  public exitBack() {
    alert('exit back')
  }

  public toggleDebugMode() {
    this.setDebugMode(!this.debugMode)
  }

  private setChecklist(v: CheckItem) {
    this.checkListValues = v
  }
}
